export const displayBrandName=name=>!name||/^j10\s*bot$/i.test(String(name).trim())?"J10 Connect":name;
